import { Injectable } from '@angular/core';
import { ComponentService } from '../../component/component.service';
import { UtilValidation } from '@formbird/shared';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class CustomFieldPreprocessorService {

  constructor(
    private componentService: ComponentService
  ) { }

  preProcess(field, document) {

    const _self = this;

    return new Promise((resolve, reject) => {

      _self.componentService.loadComponentDoc(field.componentName).then(
        function foundFunc(component: any) {

          try {

            const customFunc = component.clientPreprocessorFunction;
            if (UtilValidation.hasValue(customFunc)) {

              const clientPreprocessorFunc = Function('return (' + customFunc + ')')();
              if (component.preprocessorIsAsynchronous) {

                clientPreprocessorFunc(field, document).then(
                  function (retVal) {
                    resolve(retVal);
                  },
                  function (error) {
                    reject(error);
                  }
                );

              } else {

                const retVal = clientPreprocessorFunc(field, document);
                resolve(retVal);
              }

            } else {
              resolve(document);
            }

          } catch (err) {
            const errMsg = ('Error in running custom component preprocessor function : ' + err);
            logger.debug(errMsg);
            reject(errMsg);
          }
        },

        function notFoundFunc(err) {
          reject(err);
        }
      );
    });

  }
}
